<template>
  <div class="metrics-student-filters">
    <metrics-multi-filter
      :items="assignments"
      :value="selectedAssignments"
      :all-label="$t('metrics.allAssignments')"
      @input="$emit('update:selectedAssignments', $event)"
    />

    <eg-dropdown
      ref="dropdown"
      :text="selectedTimeFilterLabel"
      class="metrics-student-filters__time-filter"
    >
      <eg-b-dropdown-item-button
        v-for="option in timeFilterOptions"
        :key="option.value"
        :active="option.value === timeFilter"
        @click="$emit('update:timeFilter', option.value)"
      >
        {{ $t(option.labelKey) }}
      </eg-b-dropdown-item-button>
    </eg-dropdown>
  </div>
</template>

<script>
import MetricsMultiFilter from "../shared/metrics_multi_filter.vue";
import { METRICS_TIME_FILTERS } from "../../demo_data/shared.js";
import dropdownHideOnLeaveMixin from "@/mixins/dropdownHideOnLeaveMixin";

export default {
  name: "MetricsStudentFilters",

  components: {
    MetricsMultiFilter,
  },

  mixins: [dropdownHideOnLeaveMixin],

  props: {
    assignments: {
      type: Array,
      default: () => [],
    },
    selectedAssignments: {
      default: null,
    },
    timeFilter: {
      type: String,
      default: METRICS_TIME_FILTERS[0].value,
    },
  },

  data() {
    return {
      timeFilterOptions: METRICS_TIME_FILTERS,
    };
  },

  computed: {
    selectedTimeFilterLabel() {
      const found = this.timeFilterOptions.find(
        (option) => option.value === this.timeFilter
      );
      return found ? this.$t(found.labelKey) : "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../shared/metrics_card";

.metrics-student-filters {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 0 24px;

  &__time-filter {
    min-width: 130px;
    @include metrics-dropdown;
    ::v-deep .btn {
      background: var(--color-surface-neutral-background, #f7f9fa);
    }
  }
}
</style>
